"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiPartnerRestrictedZoneModel = void 0;
class ApiPartnerRestrictedZoneModel {
}
exports.ApiPartnerRestrictedZoneModel = ApiPartnerRestrictedZoneModel;
//# sourceMappingURL=api-partner-restricted-zone.model.js.map